export default __webpack_public_path__ + "static/media/MACS_logo_small.7dc0d23e.svg";